import React from 'react';
import { DataVizContainer } from '../common/DataVizContainer';
import {
  OverTimeSegmentedVizConfig,
  OverTimeSegmentedVizExternalProps,
  OverTimeSegmentedVizViews,
} from './types';
import { useOverTimeSegmentedConfigToData } from './useConfigToData';
import { overTimeViewConfigs } from './views/view-configs';

export interface OverTimeSegmentedVizProps {
  dataConfig: OverTimeSegmentedVizConfig;
  selectedView: OverTimeSegmentedVizViews;
  externalProps: OverTimeSegmentedVizExternalProps;
  persistenceKey: string;
}

export const OverTimeSegmentedViz = (props: OverTimeSegmentedVizProps) => {
  return (
    <DataVizContainer
      dataConfig={props.dataConfig}
      externalProps={props.externalProps}
      useConfigToData={useOverTimeSegmentedConfigToData}
      selectedView={props.selectedView}
      viewConfigs={overTimeViewConfigs}
      persistenceKey={props.persistenceKey}
    />
  );
};
